module.exports = __webpack_public_path__ + "static/bugbear-1-5f5f8ab60a86d93919f98af053c2de60.jpg";